import React from "react";
import Parser from "html-react-parser";
import Popup from "../Popup";
import Button from "../../UI/Button/Button";
import Image from "../../UI/Images/Image";
import "./popupResult.scss";

class PopupResult extends Popup {

  constructor(props) {
    super(props);
  }

  render() {

    const { title, subtitle } = this.props;

    return (
      <div className={"pp-popup pp-popup-result"} ref={this.ref}>
        <div className={"overlay"} />
        <div className={"box"}>
          <div className={"js-close close"}>
            <Image src={`${process.env.PUBLIC_URL}/assets/images/svg/close.svg`} />
          </div>
          <span className={"title"}>{Parser(title)}</span>
          {subtitle && <span className={"subtitle"}>{Parser(subtitle)}</span>}
          <Button className={"transparent"}
                  text={"Перейти на главную страницу"}
                  link={"https://www.lg.com/ru"} />
        </div>
      </div>
    )
  }
}

export default PopupResult;
